'use client'

import * as React from 'react'
import * as SwitchPrimitive from '@radix-ui/react-switch'

import { cn } from '@/lib/utils'

function Switch({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        'peer inline-flex h-5 w-9 shrink-0 items-center rounded-full border-2 shadow-sm transition-all duration-200 outline-none',
        // Checked state - bright green
        'data-[state=checked]:bg-[#7ed957] data-[state=checked]:border-[#7ed957]',
        // Unchecked state - visible in both modes
        'data-[state=unchecked]:bg-gray-200 data-[state=unchecked]:border-gray-300',
        'dark:data-[state=unchecked]:bg-gray-700 dark:data-[state=unchecked]:border-gray-600',
        'focus-visible:ring-2 focus-visible:ring-[#7ed957]/50 focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          'pointer-events-none block h-3.5 w-3.5 rounded-full shadow-md ring-0 transition-transform duration-200',
          // White thumb for checked, gray for unchecked
          'data-[state=checked]:bg-white data-[state=unchecked]:bg-white',
          'dark:data-[state=unchecked]:bg-gray-300',
          'data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0.5',
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }

